import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBankAccountsProfileMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#9575CD' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M20.75 23.375h-7.5c-2.25 0-3.75-1.125-3.75-3.75v-5.25c0-2.625 1.5-3.75 3.75-3.75h7.5c2.25 0 3.75 1.125 3.75 3.75v5.25c0 2.625-1.5 3.75-3.75 3.75'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M17 19.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M12.125 15.125v3.75M21.875 15.125v3.75'
    />
  </svg>
);
export default SvgBankAccountsProfileMenu;
